import { WHATSAPP_TAGS } from "@/@core/enums/whatsapp_tags.enum";
import { formatPhoneNumber } from "@/lib/format-phone-number";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  tag: WHATSAPP_TAGS;
  phone: string;
  translateValues: WhatsappCustomValues;
}

const useGetWpHref = () => {
  const { t } = useTranslation()

  const getWhatsappHrefUrl = (props: Props) => {
    const { tag, phone, translateValues } = props;

    const message = t(`whatsapp-${tag}`, translateValues);
    const encodedMessage = encodeURIComponent(message);

    const url = `whatsapp://send?phone=${formatPhoneNumber(phone)}&text=${encodedMessage}`;
    return url as string;
  };

  return getWhatsappHrefUrl;
};

export default useGetWpHref;
